import React from 'react';

import { useActiveHexContext } from 'shared/context';
import { Section } from 'components';

export const MiniHex = () => {
  const { miniHexDominantFeature } = useActiveHexContext();

  return (
    <Section column>
      <h2>Hovered mini-hex</h2>
      <h3>Dominant feature: {miniHexDominantFeature ?? 'NONE'}</h3>
    </Section>
  );
};
